import React from "react";
import { useHistory } from "react-router-dom";
import styled, { css } from "styled-components";

import { Text } from "../Text";

//links to ts&cs
const LegalPagesLinks: React.FC = () => {
  const history = useHistory();

  return (
    <LegalWrapper>
      <span>
        <Text
          onClick={() => history.push("/terms-conditions")}
          className="legalLink"
        >
          Terms & Conditions
        </Text>

        <Text className="legal">
          {" | "}
        </Text>

        <Text
          onClick={() => history.push("/privacy")}
          className="legalLink"
        >
          Privacy
        </Text>
      </span>

    </LegalWrapper>

  );
};

const LegalWrapper = styled.span`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: ${theme.spacing.padding.lg};
    
    .legal {
      color: ${theme.colors.primaryDark};
      font-size: 10px;
    }
      
    .legalLink {
      text-decoration: underline;
      cursor: pointer;
      font-size: 10px;
    }
    
  `}
`;

export default LegalPagesLinks;